<div class="upload-images" [class.small-action]="smallAction">
  @if (!hideUploadAction) {
  <div pRipple class="add-pictures-block">
    @if(smallAction){
    <img src="./../../../../assets/images/dialogs/chat/add_photo_alternate.svg" alt="upload-images" />
    } @else {
    <p class="add-pictures-title">Add pictures</p>
    <p class="optional-text">Optional</p>
    }
  </div>
  }
</div>
